import React from "react";

import { Button } from "@components/Buttons";
import { fireMxpEvent } from "@utils/mixpanelEvents/mixpanelEvents";
import { marketingCtaClicked } from "@utils/segment/marketingCtaClicked";

import styles from "./PollenSidebarCta.module.scss";

const PollenSidebarCta: React.FC<Queries.builder_PollenSidebarCtaData> = ({
  copy,
  ctaCopy,
  ctaLink,
  image,
}) => {
  const handleClick = () => {
    fireMxpEvent("user: primary cta clicked", {
      product: "pollen",
      target: ctaLink,
      text: ctaCopy,
    });

    if (ctaCopy?.toLowerCase()?.includes("start for")) {
      marketingCtaClicked({
        text: ctaCopy,
        url: window.location.pathname,
        target: ctaLink!,
      });
    }
  };

  return (
    <aside className={styles.upperSidebarCta} data-testid="pollen-sidebar-cta">
      <section className={styles.ctaMainContent}>
        <img
          alt="logo"
          className={styles.spLogo}
          data-testid="banner-icon"
          src="/icons/sp-full-logo-dark.svg"
        />

        <p
          className={styles.copy}
          dangerouslySetInnerHTML={{ __html: copy! }}
          data-testid="banner-copy"
        />

        <Button
          buttonLink={ctaLink!}
          buttonText={ctaCopy!}
          buttonType="link"
          data-testid="banner-cta-copy"
          onClick={handleClick}
          variant="primary-blue"
        />
      </section>

      <section className={styles.ctaImage}>
        <img alt="pollen cta img" data-testid="banner-cta-image" src={image!} />
      </section>
    </aside>
  );
};

export default PollenSidebarCta;
